<template>
    <span>
        <v-list-tile @click="$emit('eventoCancelarEnvioHomologacao')">
            <v-list-tile-title>
                Cancelar Envio
            </v-list-tile-title>
        </v-list-tile>
    </span>
</template>

<script>
export default {
    name: 'AcoesCancelarEnvioHomologacao'
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base)
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important
</style>